import { render, staticRenderFns } from "./DetailsCard.vue?vue&type=template&id=6e6c23ef&scoped=true"
import script from "./DetailsCard.vue?vue&type=script&lang=js"
export * from "./DetailsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e6c23ef",
  null
  
)

export default component.exports